import { ReactNode } from 'react';

import { css, cx } from '@flipster/styled-system/css';
import { grid } from '@flipster/styled-system/patterns';

interface Props {
  position: 'left' | 'right';
  trigger: ReactNode;
  dropdown: ReactNode;
}

export const Dropdown = ({ trigger, dropdown, position }: Props) => {
  return (
    <div
      className={cx(
        'dropdown',
        css({
          pos: 'relative',
          // for showing dropdown on touchscreen devices
          '&:is(:hover, [data-hover])': {
            '& .dropdown-icon': { transform: 'rotate(-180deg)' },
            '& .dropdown-menu': { display: 'block' },
          },
        }),
      )}
    >
      {trigger}
      <div
        className={cx(
          'dropdown-menu',
          css({ pos: 'absolute', zIndex: 10, display: 'none' }),
          position === 'left' && css({ left: 0 }),
          position === 'right' && css({ right: 0 }),
        )}
      >
        {/* hover 에 빈공간을 margin 으로 주면 닫히기때문에 block 으로 space 구현 */}
        <div className={css({ h: 12 })} />
        <div
          className={grid({
            gridTemplateColumns: 'max-content',
            gridRowGap: 20,
            gridColumnGap: 40,
            py: 12,
            px: 20,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'border.default.level-1',
            bgColor: 'background.default.level-1',
            rounded: 4,
          })}
        >
          {dropdown}
        </div>
      </div>
    </div>
  );
};
